import { Component } from '@angular/core';
import { adminIngestionRunEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Ingestion Runs') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-adminingestionrun-form',
    templateUrl: './adminingestionrun.form.component.html'
})
export class adminIngestionRunFormComponent extends BaseFormComponent {
    public record!: adminIngestionRunEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

